// Not Intl: Chrome ships no Icelandic number data and falls back to en-GB ("4.6").
export const formatQualityScore = (score: number) => `${score.toFixed(1).replace('.', ',')}/5`;
